export default __webpack_public_path__ + "static/media/gold.9509f59f.svg";